import type { UserProfile } from "@/services/authService";
import { isRapidPlan } from "@/utils/accessControl";
import { ALL_STATUSES } from "./roomFilterDraft";

export const ROOM_STATUS_SORT_FIELD = "status";

export function shouldShowStatusColumn(
  userProfile: UserProfile | null,
): boolean {
  return !isRapidPlan(userProfile);
}

export function shouldShowStatusFilter(
  userProfile: UserProfile | null,
): boolean {
  return !isRapidPlan(userProfile);
}

export function shouldStatusFilterBeReset(
  userProfile: UserProfile | null,
  status: string,
): boolean {
  return status !== ALL_STATUSES && !shouldShowStatusFilter(userProfile);
}

export function shouldSortBeReset(
  userProfile: UserProfile | null,
  sortField: string | null,
): boolean {
  return (
    sortField === ROOM_STATUS_SORT_FIELD && !shouldShowStatusColumn(userProfile)
  );
}
